var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { AttentionSolid, CheckmarkCircleSolid, CrossCircleSolid, InfoCircleSolid, RocketSolid, } from '../icon';
import { backgroundStyle, iconStyle, wrapperStyle } from './styles';
function NotificationIcon(_a) {
    var _b = _a.isCentered, isCentered = _b === void 0 ? false : _b, _c = _a.size, size = _c === void 0 ? 'medium' : _c, _d = _a.variant, variant = _d === void 0 ? 'info' : _d, restProps = __rest(_a, ["isCentered", "size", "variant"]);
    function renderIcon() {
        switch (variant) {
            case 'success':
                return _jsx(CheckmarkCircleSolid, __assign({ size: size }, restProps));
            case 'warning':
                return _jsx(AttentionSolid, __assign({ size: size }, restProps));
            case 'error':
                return _jsx(CrossCircleSolid, __assign({ size: size }, restProps));
            case 'upgrade':
                return _jsx(RocketSolid, __assign({ size: size }, restProps));
            case 'info':
            default:
                return _jsx(InfoCircleSolid, __assign({ size: size }, restProps));
        }
    }
    return (_jsxs("div", __assign({ css: wrapperStyle({ isCentered: isCentered }), "data-testid": "notification-icon" }, { children: [_jsx("div", { css: backgroundStyle({ variant: variant }) }), _jsx("div", __assign({ css: iconStyle({ variant: variant }) }, { children: renderIcon() }))] })));
}
export default NotificationIcon;
